export default "__VITE_ASSET__DPc7Nmno__"